"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fish = exports.Source = void 0;
var eva_js_1 = require("@eva/eva.js");
var plugin_renderer_img_1 = require("@eva/plugin-renderer-img"); // 引入渲染图片所需要的组件和系统
var plugin_renderer_text_1 = require("@eva/plugin-renderer-text");
var plugin_transition_1 = require("@eva/plugin-transition");
var plugin_renderer_sprite_animation_1 = require("@eva/plugin-renderer-sprite-animation");
var plugin_renderer_event_1 = require("@eva/plugin-renderer-event");
var render_1 = __importDefault(require("../../render"));
var cat_1 = __importDefault(require("../../cat"));
// 资源
exports.Source = [{
        name: 'fish',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/fish_coin/full.png'
            },
            json: {
                type: 'json',
                url: './resource3d/fish_coin/full.json'
            }
        },
        preload: true
    }, {
        name: 'empty',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/fish_coin/empty.png'
            },
            json: {
                type: 'json',
                url: './resource3d/fish_coin/empty.json'
            }
        },
        preload: true
    }, {
        name: 'fish3',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/fish/003.png'
            },
            json: {
                type: 'json',
                url: './resource3d/fish/003.json'
            }
        },
        preload: true
    }, {
        name: 'fall',
        type: eva_js_1.RESOURCE_TYPE.SPRITE_ANIMATION,
        src: {
            image: {
                type: 'png',
                url: './resource3d/fish/fall.png'
            },
            json: {
                type: 'json',
                url: './resource3d/fish/fall.json'
            }
        },
        position: {},
        preload: true
    }];
var timer = null;
var SmallFish = /** @class */ (function () {
    function SmallFish() {
        this.frames = 0;
        this.eatFishStartOver = false;
        this.initResource();
    }
    SmallFish.prototype.initResource = function () {
        render_1.default.addResource(exports.Source).addSystem([new plugin_renderer_text_1.TextSystem(), new plugin_transition_1.TransitionSystem(), new plugin_renderer_sprite_animation_1.SpriteAnimationSystem(), new plugin_renderer_img_1.ImgSystem(), new plugin_renderer_event_1.EventSystem()]);
    };
    // 初始化鱼动画容器
    SmallFish.prototype.initFishGame = function () {
        this.goldGame();
    };
    SmallFish.prototype.goldGame = function () {
        for (var _i = 0, _a = ['fish', 'fall']; _i < _a.length; _i++) {
            var i = _a[_i];
            var position = {
                x: 0,
                y: 43
            };
            var size = {
                width: 69,
                height: 80
            };
            if (i === 'fall') {
                position = {
                    x: 10,
                    y: 40
                };
                size = {
                    width: 50,
                    height: 70
                };
            }
            this[i] = new eva_js_1.GameObject(i, {
                size: size,
                origin: { x: 0, y: 0 },
                position: position,
                anchor: {
                    x: 0,
                    y: 0
                },
                scale: {
                    x: 0.8,
                    y: 0.8
                }
            });
            this[i + 'SpriteAnimation'] = this[i].addComponent(new plugin_renderer_sprite_animation_1.SpriteAnimation({
                resource: i,
                autoPlay: false,
                speed: 40
            }));
        }
        this.addListenterAnimation();
    };
    // 添加动画监听
    SmallFish.prototype.addListenterAnimation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.frames = 0;
                this.fishSpriteAnimation.on('frameChange', function (a) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (this.frames >= 13) {
                            this.frames = 0;
                            this.fishSpriteAnimation.stop();
                            if (this.fishSpriteAnimation.resource === 'fish') {
                                this.startEatFish();
                            }
                            else if (this.fishSpriteAnimation.resource === 'empty') {
                                this.eatFishStartOver = false;
                            }
                        }
                        this.frames++;
                        return [2 /*return*/];
                    });
                }); });
                // 小鱼堆满
                this.fishSpriteAnimation.on('complete', function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.startEatFish();
                        return [2 /*return*/];
                    });
                }); });
                // 掉落效果结束
                this.fallSpriteAnimation.on('complete', function () {
                });
                return [2 /*return*/];
            });
        });
    };
    //开始吃鱼   吃鱼有两种情况1、待机动画时唤醒去吃鱼 2、坐下来继续吃鱼
    SmallFish.prototype.startEatFish = function () {
        var _this = this;
        this.eatFishStartOver = true;
        cat_1.default.fishFallOverStartEat(function () {
            _this.fishHide();
        });
    };
    // 猫咪主动吃鱼的时候调用：即cat内调用
    SmallFish.prototype.fishStartEmpty = function () {
        this.emptyFish();
    };
    // 猫咪主动吃鱼的时候调用：即cat内调用
    SmallFish.prototype.fishHide = function () {
        this.fish.transform.scale = {
            x: 0,
            y: 0
        };
    };
    Object.defineProperty(SmallFish.prototype, "getFish", {
        // @ts-ignore
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    // 切换动画
    SmallFish.prototype.changeAnimation = function (name, time) {
        if (time === void 0) { time = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.frames = 0;
                        this.fishSpriteAnimation.resource = name;
                        this.fishSpriteAnimation.play(time);
                        if (name === 'empty') {
                            this.fishSpriteAnimation.speed = 300;
                        }
                        else {
                            this.fishSpriteAnimation.speed = 40;
                        }
                        _a = this;
                        return [4 /*yield*/, eva_js_1.resource.getResource(name)];
                    case 1:
                        _a.totalFrames = (_b.sent()).instance.length - 2;
                        return [2 /*return*/];
                }
            });
        });
    };
    // 掉鱼
    SmallFish.prototype.fallFish = function () {
        this.fallSpriteAnimation.stop();
        this.fishSpriteAnimation.stop();
        this.fish.transform.scale = {
            x: 0.8,
            y: 0.8
        };
        this.changeAnimation('fish');
        this.fallSpriteAnimation.play(1);
    };
    SmallFish.prototype.emptyFish = function () {
        this.changeAnimation('empty', 1);
    };
    SmallFish.prototype.load = function (name) {
        render_1.default.renderGame(this[name]);
        return Promise.resolve(true);
    };
    return SmallFish;
}());
exports.Fish = new SmallFish();
